export function makeOtherDetails(details) {
  return {
      verifiedAt: details.verified_at
  };
}

class ProfileStore {
  constructor(ProfileApiService, DashboardApiService) {
    'ngInject';

    this.ProfileApiService = ProfileApiService;
    this.DashboardApiService = DashboardApiService;
  }

  getDashboardDetails() {
    return this.DashboardApiService.dashboard().then((details) => {
      return {
        others: makeOtherDetails(details),
      };
    });
  }

  getProfile() {
    return this.ProfileApiService.profile();
  }
}

export default ProfileStore;



// WEBPACK FOOTER //
// ./client/app/pages/profile/store/profile.store.js